import React, { useCallback } from 'react';
import { ICON_PATHS } from '../utils/iconSvgPaths';

const dashToSvg = (dash) => {
  switch (dash) {
    case 'dot':     return '3,3';
    case 'dash':    return '8,4';
    case 'dashdot': return '8,4,3,4';
    case 'longdash': return '16,4';
    default:        return undefined;
  }
};

const LegendIcon = ({ item }) => {
  if (item.type === 'signal' || item.type === 'alarm') {
    return (
      <svg width="28" height="12" style={{ flexShrink: 0 }}>
        <line
          x1="2" y1="6" x2="26" y2="6"
          stroke={item.color}
          strokeWidth="2"
          strokeDasharray={dashToSvg(item.dash)}
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (item.type === 'label') {
    return (
      <svg width="12" height="12" style={{ flexShrink: 0 }}>
        <circle cx="6" cy="6" r="5" fill={item.color} />
      </svg>
    );
  }
  if (item.type === 'category') {
    const entry = ICON_PATHS[item.iconType];
    if (entry) {
      return (
        <svg width="14" height="14" viewBox={entry.viewBox} style={{ flexShrink: 0 }}>
          {entry.d.map((d, i) => <path key={i} d={d} fill={item.color} />)}
        </svg>
      );
    }
    return (
      <svg width="12" height="12" style={{ flexShrink: 0 }}>
        <circle cx="6" cy="6" r="5" fill={item.color} />
      </svg>
    );
  }
  return <span style={{ width: 16, flexShrink: 0, display: 'inline-block' }} />;
};

const CustomLegend = ({ items, hiddenGroups, onToggle, onIsolate }) => {
  const handleClick = useCallback((e, id) => {
    e.stopPropagation();
    onToggle(id);
  }, [onToggle]);

  const handleDoubleClick = useCallback((e, id) => {
    e.preventDefault();
    e.stopPropagation();
    onIsolate(id);
  }, [onIsolate]);

  if (!items || items.length === 0) return null;

  return (
    <div className="leg-custom-legend">
      {items.map((item) => {
        const hidden = hiddenGroups.has(item.id);
        return (
          <div
            key={item.id}
            className={`leg-legend-item${hidden ? ' leg-legend-item--hidden' : ''}`}
            onClick={(e) => handleClick(e, item.id)}
            onDoubleClick={(e) => handleDoubleClick(e, item.id)}
            title={item.fullName || item.name}
          >
            <LegendIcon item={item} />
            <span
              className="leg-legend-name"
              style={item.type === 'category' || item.type === 'label' ? { color: item.color } : undefined}
            >
              {item.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default CustomLegend;
